import React from 'react';

const WillsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex flex-col" data-testid="wills-page">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-slate-200 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-2" data-testid="wills-home-link">
            <span className="text-2xl font-bold text-teal-600">PMS</span>
            <span className="text-2xl font-bold text-slate-800">Kart</span>
          </a>
          <a
            href="/"
            className="text-sm text-teal-600 hover:text-teal-700 font-medium"
            data-testid="wills-back-home"
          >
            ← Back to Home
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 py-6 flex flex-col">
        <div className="text-center mb-4">
          <h1 className="text-3xl font-bold text-slate-800 mb-1">Wills</h1>
          <p className="text-slate-600">Create your will with our AI-powered assistant</p>
        </div>

        {/* Iframe Container — fills remaining viewport so the embed has full space regardless of its internal content */}
        <div
          className="bg-white rounded-xl shadow-lg p-2 md:p-3 flex-1"
          style={{ minHeight: 'calc(100vh - 220px)' }}
        >
          <iframe
            id="willkart-embed"
            src="https://www.willkart.ai/embed/534c8335-d00a-48e4-be02-3b5b5c323605/client"
            style={{
              width: '100%',
              height: '100%',
              minHeight: 'calc(100vh - 240px)',
              border: 'none',
              borderRadius: '12px',
              display: 'block',
            }}
            allow="clipboard-write"
            title="Wills - WillKart AI"
            data-testid="wills-iframe"
          />
        </div>
      </main>
    </div>
  );
};

export default WillsPage;
